export default class ChangePasswordViewModel {
    id: string = ""
    oldPassword: string = ""
    newPassword: string = ""
    newPasswordConf: string = ""
};